import { SelectClassKey } from "@mui/material";
import { OverridesStyleRules } from "@mui/material/styles/overrides";

export const selectStyles: Partial<OverridesStyleRules<SelectClassKey>> = {
    select: {},
};
